/**
 * Platform detection utilities for Capacitor mobile app.
 *
 * Use these to conditionally enable native features only when
 * running inside the Capacitor shell (Android/iOS).
 */

/**
 * Returns true if the app is running inside Capacitor (native mobile).
 */
export function isNativePlatform() {
  return typeof window !== 'undefined' && window.Capacitor !== undefined;
}

/**
 * Returns the platform: 'android', 'ios', or 'web'.
 */
export function getPlatform() {
  if (!isNativePlatform()) return 'web';
  return window.Capacitor?.getPlatform?.() || 'web';
}

/**
 * Returns true if running on Android.
 */
export function isAndroid() {
  return getPlatform() === 'android';
}

/**
 * Returns true if running on iOS.
 */
export function isIOS() {
  return getPlatform() === 'ios';
}

/**
 * Returns true if running on mobile (either native or mobile browser).
 */
export function isMobileDevice() {
  if (isNativePlatform()) return true;
  if (typeof window === 'undefined') return false;
  return window.innerWidth < 768 || /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
}
